// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 385) return "icecast-metadata-player-1.17.12.common.min.js";
	// return url for filenames based on template
	return "icecast-metadata-player-1.17.12." + {"88":"mpeg","398":"vorbis","694":"opus","731":"synaudio","762":"mediasource","993":"flac"}[chunkId] + ".min.js";
};